var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var VideoController = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/videoplayer/content/{n1}/{n2?}/{n3?}/{n4?}/{n5?}/{n6?}/{n7?}/{n8?}/{n9?}/{n10?}/{n11?}/{n12?}/{n13?}/{n14?}/{n15?}/{n16?}/{n17?}/{n18?}/{n19?}/{n20?}" and http method "GET" to call the back-end.
    
        * @param {string} n1
        * @param {string} n2
        * @param {string} n3
        * @param {string} n4
        * @param {string} n5
        * @param {string} n6
        * @param {string} n7
        * @param {string} n8
        * @param {string} n9
        * @param {string} n10
        * @param {string} n11
        * @param {string} n12
        * @param {string} n13
        * @param {string} n14
        * @param {string} n15
        * @param {string} n16
        * @param {string} n17
        * @param {string} n18
        * @param {string} n19
        * @param {string} n20
        * @returns {void}
    ******************************************************************************************************/
    GetContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/videoplayer/content/{n1}/{n2?}/{n3?}/{n4?}/{n5?}/{n6?}/{n7?}/{n8?}/{n9?}/{n10?}/{n11?}/{n12?}/{n13?}/{n14?}/{n15?}/{n16?}/{n17?}/{n18?}/{n19?}/{n20?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=VideoController.js.map